// extracted by mini-css-extract-plugin
export default {"Hosting":"Style_Hosting__3QPJt","Menu":"Style_Menu__dquOx","Obsah":"Style_Obsah__iGhg-","Button_Active":"Style_Button_Active__d9hwu"};